module.exports = __webpack_public_path__ + "img/contents.cf42c52a.png";